import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import NewsletterPopup from "@/components/NewsletterPopup";
import ActivityFeed from "@/components/ActivityFeed";
import AgeGate from "@/components/AgeGate";

export default function Layout() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background text-white">
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
      <NewsletterPopup />
      <ActivityFeed />
      <AgeGate />
    </div>
  );
}
